export const getOptionalExtras = pricingMatrix => {
  const extras = []

  pricingMatrix.forEach(section => {
    section.rows.forEach(row => {
      const isExtra =
        row.merge === true &&
        row.cells.some(
          cell => cell.value && typeof cell.value.amount === "number",
        )

      if (isExtra) {
        extras.push(row.name)
      }
    })
  })

  return extras.map((label, index) => ({
    label,
    key: index,
  }))
}
